let contactUsIds = {
    contact_us_name_label                       :   "Contact us",
    before_you_contact_us_and_continue_label    :   " Before you contact us, we suggest you to check our FAQs section to see if your questions have been answered.",
    in_case_any_query_label                     :   "In case you're stuck with a unique issue, feel free to reach out to us.",
    contact_email_label                         :   "admin.frames@oyorooms.com"
}

export default {
    ...contactUsIds
}